import { Checkbox, Tooltip } from "@mui/material";
import { ArrowLeft, Edit } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../../API/newIndex";
import { DataLoad } from "../../App";
import { NOPHOTO_IMAGE } from "../../Assets/StaticData/StaticImage";
import Breadcrumbs from "../../controllers/breadCrumbs";
import { formatDate } from "../../controllers/FormatAmount";
import MuiSwitch from "../../controllers/MuiSwitch";
import { parentNavigate } from "../../controllers/ParentNavigate";
import NoRecords from "../Main/NoRecords";
import Notification from "../Notification";
import { CommonTable, ButtonComponent } from '@shopeasy-dashboard-ui/ui-library';
import AddPortfolioComments from "./AddPortfolioComments";
import { useLastRoute } from "../../controllers/LastRouteContext";

const PerticularPortfolioComment = () => {
  const params = useParams();
  const [PortfolioComments, setPortfolioComments] = useState();
  const { dataLoading, setDataLoading } = useContext(DataLoad);
  const [selectedRowsId, setSelectedRowsId] = useState([]);
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [clearRow, setClearRow] = useState(false);
  const [severity, setSeverity] = useState();
  const lastRoute = useLastRoute();

  const GetPortfolioComments = async () => {
    setDataLoading(true);
    try {
      let ApiCall = await API({
        url: `/admin/portfolio/getparticularPortfolioComment/${params?.commentId}`,
        method: "get",
      });
      const result = ApiCall?.data;
      setPortfolioComments(result);
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    } finally {
      setDataLoading(false);
    }
  };

  const DisableComment = async (id, value) => {
    try {
      const payload = {
        is_visible: value,
      };
      await API({
        url: `/admin/portfolio/UpdatePortfolioComment/${id}`,
        method: "put",
        data: payload,
      });
      GetPortfolioComments();
      setIsNotification(true);
      setNotificationMsg(
        value ? "portfolio comment is set to active" : "portfolio comment is set to hidden",
      );
      setSeverity("success");
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  const UpdateManyComments = async (value) => {
    try {
      const payload = {
        id: selectedRowsId,
        is_visible: value,
      };
      await API({
        url: "/admin/portfolio/UpdateManyPortfolioComment",
        method: "put",
        data: payload,
      });
      GetPortfolioComments();
      setSelectedRowsId([]);
      setClearRow(!clearRow);
      setIsNotification(true);
      setNotificationMsg(`Comments set to ${value ? "active" : "hidden"}`);
      setSeverity("success");
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  const [editCommentData, setEditCommentData] = useState();

  const closeAddComment = (value) => {
    setIsAddComment(false);
    if (value === "call api") {
      GetPortfolioComments();
    }
  };

  const [commentRef] = useState(null);
  const [isAddComment, setIsAddComment] = useState(false);

  useEffect(() => {
    GetPortfolioComments();
  }, []);

  const portfolioData = PortfolioComments?.data?.portfolioId;

  const handleSelectRow = (e, id) => {
    if (e?.nativeEvent?.shiftKey) {
      const prevIndex = PortfolioComments?.data?.records?.findIndex(
        (x) => x._id === selectedRowsId[selectedRowsId?.length - 1],
      );
      const currIndex = PortfolioComments?.data?.records?.findIndex((x) => x._id === id);
      const startIndex = Math.min(prevIndex, currIndex);
      const endIndex = Math.max(prevIndex, currIndex);
      const final = PortfolioComments?.data?.records?.slice(startIndex, endIndex + 1);

      if (selectedRowsId?.includes(id)) {
        setSelectedRowsId((prev) => [
          ...new Set(prev.filter((x) => !final.find((item) => item._id === x))),
        ]);
      } else {
        setSelectedRowsId((prev) => [...new Set([...prev, ...final.map((item) => item._id)])]);
      }
    } else if (id === "all") {
      if (selectedRowsId?.length > 0) {
        setSelectedRowsId([]);
      } else {
        setSelectedRowsId(PortfolioComments?.data?.records?.map((x) => x?._id));
      }
    } else {
      const existId = selectedRowsId?.includes(id);
      if (!existId) {
        setSelectedRowsId((prev) => [...prev, id]);
      } else {
        setSelectedRowsId((prev) => prev.filter((x) => x !== id));
      }
    }
  };

  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  const columns = [
    {
      key: "checkbox",
      title: (
        <Checkbox
          checked={
            (PortfolioComments?.data?.records?.length || 0) > 0 &&
            selectedRowsId?.length === PortfolioComments?.data?.records?.length
          }
          indeterminate={
            selectedRowsId?.length > 0 &&
            selectedRowsId?.length < (PortfolioComments?.data?.records?.length || 0)
          }
          onChange={(e) => handleSelectRow(e, "all")}
        />
      ),
      align: "text-center",
      ignoreRowClick: true,
      width: "50px",
      minWidth: "50px",
      maxWidth: "50px",
      headerClassName: "!px-0 w-[50px] min-w-[50px] max-w-[50px] text-center",
      cellClassName: "!px-0 w-[50px] min-w-[50px] max-w-[50px] text-center",
      render: (row) => (
        <Checkbox
          checked={selectedRowsId?.length > 0 && selectedRowsId?.includes(row._id)}
          onChange={(e) => handleSelectRow(e, row._id)}
        />
      ),
    },
    {
      key: "profile_picture",
      title: t("lang_profile_picture") || "Profile Picture",
      width: "75px",
      minWidth: "70px",
      maxWidth: "85px",
      responsiveWidth: "60px",
      headerClassName: "thead-image px-2 text-center",
      cellClassName: "table-image px-2 text-center",
      align: "text-center",
      render: (row) => (
        <img
          width={40}
          height={50}
          onError={(e) => {
            e.target.src = NOPHOTO_IMAGE;
          }}
          src={row?.profile_picture || NOPHOTO_IMAGE}
          className="p-0.5 max-h-full rounded-md mx-auto block"
          alt={row?.name || "profile"}
        />
      ),
    },
    {
      key: "name",
      title: t("lang_author_name") || "Author Name",
      width: "180px",
      minWidth: "150px",
      headerClassName: "px-3 capitalize",
      cellClassName: "px-3",
      render: (row) => (
        <span className="text-xs font-medium text-[var(--primary-text-color)] capitalize">
          {row?.name || "-"}
        </span>
      ),
    },
    {
      key: "email",
      title: t("lang_email") || "Email",
      width: "180px",
      minWidth: "150px",
      headerClassName: "px-3 capitalize",
      cellClassName: "px-3",
      render: (row) => (
        <span className="text-xs text-[var(--primary-text-color)]">
          {row?.email || "-"}
        </span>
      ),
    },
    {
      key: "comment",
      title: t("lang_comment") || "Comment",
      width: "350px",
      minWidth: "200px",
      headerClassName: "px-3 capitalize",
      cellClassName: "px-3",
      render: (row) => (
        <span className="text-xs text-[var(--primary-text-color)] line-clamp-2">
          {row?.comment || "-"}
        </span>
      ),
    },
    {
      key: "createdAt",
      title: t("lang_date") || "Date",
      width: "120px",
      minWidth: "110px",
      headerClassName: "px-3 text-right capitalize whitespace-nowrap",
      cellClassName: "px-3 text-right whitespace-nowrap",
      align: "text-right",
      render: (row) => (
        <span className="text-xs text-[var(--primary-text-color)] whitespace-nowrap">
          {formatDate(row?.createdAt)}
        </span>
      ),
    },
    {
      key: "is_visible",
      title: t("lang_active") || "Active",
      width: "100px",
      minWidth: "100px",
      headerClassName: "px-3 text-right capitalize whitespace-nowrap",
      cellClassName: "px-3 text-right whitespace-nowrap",
      align: "text-right",
      ignoreRowClick: true,
      render: (row) => (
        <div className="flex items-center justify-end w-full">
          <MuiSwitch
            checked={row?.is_visible === true}
            onChange={() => {
              DisableComment(row._id, !row?.is_visible);
            }}
          />
        </div>
      ),
    },
    {
      key: "action",
      title: t("lang_action") || "Action",
      width: "80px",
      minWidth: "80px",
      headerClassName: "px-3 text-right capitalize whitespace-nowrap",
      cellClassName: "px-3 text-right whitespace-nowrap",
      align: "text-right",
      ignoreRowClick: true,
      render: (row) => (
        <div className="flex items-center justify-end w-full">
          <Tooltip title="Edit" arrow>
            <button
              onClick={(e) => {
                e.preventDefault();
                setIsAddComment(true);
                setEditCommentData(row);
              }}
            >
              <Edit className="h-4 w-4 text-[var(--table-text-color)] hover:text-[var(--primary-text-color)] transition-colors" />
            </button>
          </Tooltip>
        </div>
      ),
    },
  ];

  const tableHeader = () => {
    return (
      <div className="flex p-3 border-b main-border-color secondary-bg-color items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 flex items-center justify-center rounded-lg overflow-hidden bg-gray-100 dark:bg-zinc-800 shrink-0 border border-[var(--border-color)]">
            <img
              className="max-w-full max-h-full object-contain"
              onError={(e) => {
                e.target.src = NOPHOTO_IMAGE;
              }}
              src={portfolioData?.image || NOPHOTO_IMAGE}
              alt={portfolioData?.title || "portfolio image"}
            />
          </div>
          <h6 className="text-base font-medium text-[var(--primary-text-color)] m-0">
            {portfolioData?.title || ""}
          </h6>
        </div>

        {selectedRowsId && selectedRowsId?.length > 0 && (
          <div className="flex items-center gap-2">
            <span className="text-sm px-2">
              {selectedRowsId?.length} {t("lang_selected")}
            </span>
            <span className="me-1">|</span>
            <ButtonComponent
              variant="secondary"
              size="sm"
              onClick={() => UpdateManyComments(false)}
            >
              {t("lang_Hide_Comments")}
            </ButtonComponent>
            <ButtonComponent
              variant="primary"
              size="sm"
              onClick={() => UpdateManyComments(true)}
            >
              {t("lang_Show_Comments")}
            </ButtonComponent>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      <div className="h-auto overflow-y-auto pb-[64px] p-5">
        <div className="flex items-center space-x-2 page-header-pb">
          <button
            onClick={(e) => {
              e.preventDefault();
              parentNavigate(lastRoute);
            }}
            className="back-arrow -ml-3.5"
          >
            <ArrowLeft />
          </button>
          <div>
            <Breadcrumbs
              crumbs={[
                { name: t("lang_Portfolio_Comments"), path: lastRoute },
                { name: t("lang_View_Comments"), path: "/portfolio/comments/view-comments" },
              ]}
            />
            <h4 className="text-xl md:text-2xl font-semibold text-primary">
              {t("lang_Perticular_Portfolio_comments")}
            </h4>
          </div>
        </div>
        <div className="w-full space-y-4">
          <div className="w-full transition-all duration-100">
            <CommonTable
              columns={columns}
              data={PortfolioComments?.data?.records}
              tableHeader={tableHeader()}
              loading={dataLoading}
              emptyMessage={<NoRecords />}
              containerClassName="module-table overflow-x-auto border border-[var(--border-color)] rounded-xl shadow-[var(--shadow-card)]"
            />
          </div>
          <ButtonComponent
            variant="link"
            icon={<ArrowLeft className="w-3.5 h-3.5" />}
            onClick={(e) => {
              e.preventDefault();
              parentNavigate(lastRoute || "/portfolio/comments");
            }}
            className="text-primary"
          >
            {t("lang_Go_To_All_Portfolio_Comments")}
          </ButtonComponent>
        </div>
      </div>
      <AddPortfolioComments
        commentRef={commentRef}
        isAddComment={isAddComment}
        closeAddComment={closeAddComment}
        editCommentData={editCommentData}
        type="edit"
      />
    </>
  );
};

export default PerticularPortfolioComment;
